import React, { useEffect, useMemo, useState } from 'react';
import { CustomSelect } from 'web-library';
import FormControl from 'web-library/stories/atom/FormControl/FormControl';


import { makeStyles } from 'tss-react/mui';
import { MenuItems } from './model';
import { CodeValueResponse } from '../../api';
import { useGetSchoolOptions } from '../../api/candidate/resit/@opadmin/queries-services/queries';
import { SelectChangeEvent } from '@mui/material';

const useStyles = makeStyles()((theme) =>
({
  fromControlContainer: {
    display: 'flex',
    marginBottom: theme.spacing(3),
    width: '100%'
  },
}));

export interface SchoolMultiSelectProps {
  /** to handle select on change event
   * */
  onChange?: (event: CodeValueResponse[]) => void;

  /** to define select control selected value
   * */
  value: string[];

  /** to define option label
   * * */
  label: string;
}

/** reusable select component for school option
 * */
const SchoolMultiSelect: React.FC<SchoolMultiSelectProps> = (props: SchoolMultiSelectProps) => {
  const { onChange = (event: CodeValueResponse[]) => {
    // do nothing
  }, value = [], label } = props;
  const [schools, setSchools] = useState<CodeValueResponse[]>([]);

  const { classes } = useStyles();

  const { refetch } = useGetSchoolOptions({
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    onSuccess: (responseData) => {
      if (responseData && responseData.length > 0) {
        setSchools(responseData);
      }
    },
  });

  /** reform data into CustomSelect MenuItems
   * */
  const dropDownData = useMemo<MenuItems[]>(() => {
    if (!schools) {
      return [];
    }
    return schools.map((option) => ({
      children: option.codeValueDescription,
      value: option.codeId,
      key: `k-${option.codeId}`,
    }));
  }, [schools]);

  /** handle select on Change
   * */
  const onSelectOptionChange = async (selectedValue: any[] | unknown) => {
    if (schools && schools.length > 0 && Array.isArray(selectedValue)) {
      onChange(schools.filter((school) => selectedValue.includes(school.codeId)));
    }
  };

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <FormControl className={classes.fromControlContainer}>
      <CustomSelect
        displayEmpty
        defaultValue={undefined}
        inputProps={{ style: { width: 100 } }}
        label={label}
        labelId="inputSelectLabel-schoolOptions"
        id="inputSelect-schoolOptions"
        onChange={(e: SelectChangeEvent<unknown>) => {
          onSelectOptionChange(e.target.value);
          window.dispatchEvent(new CustomEvent('resize'));
        }}
        menuItems={dropDownData}
        value={value}
        variant="filled"
        multiple
        renderValue={(selected: unknown | string[]) =>
          Array.isArray(selected) && selected.length > 0
            ? schools
              .filter((school) => selected.includes(school.codeId))
              .map((s) => s.codeValueDescription)
              .join(', ')
            : 'Select Schools'
        }
      />
    </FormControl>
  );
};
export default SchoolMultiSelect;
